import * as React from "react";

export default  function SkeletonSwitch({
  isLoading,
  skeleton,
  children,
}: {
  isLoading: boolean;
  skeleton: React.ReactNode;
  children: React.ReactNode;
}) {
  return <>{isLoading ? skeleton : children}</>;
}
